class UrlFilterHelper {
  constructor() {
    this.filters = this.getFiltersFromUrl();
  }

  getFiltersFromUrl() {
    let filters = [];
    let urlSearchParams = new URLSearchParams(window.location.search);
    let filtersString = urlSearchParams.get("filters");

    if (filtersString) {
      let filterParams = new URLSearchParams(filtersString);

      filterParams.forEach((value, key) => {
        var obj = Object.create(null);

        if (value.indexOf("~") > -1) {
          obj = {
            id: key,
            selectedMin: value.split("~")[0],
            selectedMax: value.split("~")[1],
            type: 3,
          };
        } else {
          obj = {
            id: key,
            items: value
              .split("|")
              .map((str) => {
                let value = str;

                let split = str.split(":");
                if (split.length != 2) {
                  return null;
                }

                let text = split[1];
                return {
                  value: value,
                  text: text,
                  selected: true,
                };
              })
              .filter((item) => item != null),
          };
        }

        filters.push(obj);
      });
    }

    return filters;
  }

  getFilters() {
    return this.filters || [];
  }

  setFilters(filterGroups) {
    let selectedFilterGroups = [];

    filterGroups.forEach((filterGroup) => {
      if (filterGroup.items?.length > 0 && filterGroup.type !== 3) {
        let selectedItems = filterGroup.items.filter((item) => item.selected);
        if (selectedItems.length) {
          selectedFilterGroups.push({
            id: filterGroup.id,
            items: selectedItems,
          });
        }
      } else {
        // interval
        if (filterGroup.type === 3 && filterGroup.selectedMin !== null && filterGroup.selectedMax !== null) {
          selectedFilterGroups.push(filterGroup);
        }
      }
    });

    if (selectedFilterGroups.length == 0) {
      this.setQueryStringValue("filters", "");
      return;
    }

    let filterString = this.join("&", selectedFilterGroups, (filterGroup) => {
      if (filterGroup.items?.length > 0 && filterGroup.type !== 3) {
        return (
          filterGroup.id +
          "=" +
          this.encode(
            this.join("|", filterGroup.items, (item) => {
              return item.value;
            })
          )
        );
      } else {
        if (filterGroup.type === 3 && filterGroup.selectedMin !== null && filterGroup.selectedMax !== null) {
          return filterGroup.id + "=" + this.encode(filterGroup.selectedMin + "~" + filterGroup.selectedMax);
        }
      }
    });

    this.setQueryStringValue("filters", filterString);

    return filterString;
  }

  setQueryStringValue(key, value) {
    let urlSearchParams = new URLSearchParams(window.location.search);
    urlSearchParams.set(key, value);
    window.history.replaceState(null, null, "?" + urlSearchParams.toString() + window.location.hash);
  }

  join(separator, arr, func) {
    if (!arr) {
      return "";
    }

    let result = "";
    arr.forEach((element) => {
      result += separator + func(element);
    });

    return result.substring(separator.length);
  }

  deleteQueryString(paramName) {
    let urlSearchParams = new URLSearchParams(window.location.search);

    if (urlSearchParams.has(paramName)) {
      urlSearchParams.delete(paramName);
      window.history.replaceState(null, null, "?" + urlSearchParams.toString() + window.location.hash);
    }
  }

  getQueryString(paramName) {
    let urlSearchParams = new URLSearchParams(window.location.search);

    return urlSearchParams.has(paramName) ? urlSearchParams.get(paramName) : null;
  }

  encode(str) {
    return encodeURIComponent(str);
  }

  decode(str) {
    return decodeURIComponent(str);
  }
}

export default UrlFilterHelper;
